import type { Field } from "./types.ts";

const FIELD_SELECTOR: Record<Field, string> = {
  due: ".col-due input",
  supplier: ".col-supplier input",
  amount: ".col-amount input",
};

export function focusRowField(rowId: string, field: Field): void {
  const tr = document.querySelector(`tr[data-row-id="${CSS.escape(rowId)}"]`);
  const inp = tr?.querySelector(FIELD_SELECTOR[field]) as HTMLElement | null;
  inp?.focus();
}

export function nextSiblingRow(tr: Element): HTMLElement | null {
  let s = tr.nextElementSibling;
  while (s && !s.classList.contains("row")) s = s.nextElementSibling;
  return s as HTMLElement | null;
}

export function prevSiblingRow(tr: Element): HTMLElement | null {
  let s = tr.previousElementSibling;
  while (s && !s.classList.contains("row")) s = s.previousElementSibling;
  return s as HTMLElement | null;
}

export function focusSiblingRow(
  currentTr: Element,
  direction: "next" | "prev",
  field: Field,
): void {
  const sibling =
    direction === "next"
      ? nextSiblingRow(currentTr)
      : prevSiblingRow(currentTr);
  const id = sibling?.dataset.rowId;
  if (id) focusRowField(id, field);
}

const FIELD_ORDER: Field[] = ["due", "supplier", "amount"];

export function focusAdjacentField(
  tr: Element,
  currentField: Field,
  direction: "next" | "prev",
): void {
  const i = FIELD_ORDER.indexOf(currentField);
  const j = direction === "next" ? i + 1 : i - 1;
  const target = FIELD_ORDER[j];
  if (target === undefined) return;
  const id = (tr as HTMLElement).dataset.rowId;
  if (id) focusRowField(id, target);
}

export function fieldFromElement(el: Element | null | undefined): Field | null {
  const cls = el?.parentElement?.className ?? "";
  if (cls.includes("col-supplier")) return "supplier";
  if (cls.includes("col-amount")) return "amount";
  if (cls.includes("col-due")) return "due";
  return null;
}
